document.addEventListener('DOMContentLoaded', function() {
  const backLinks = document.querySelectorAll('.mobile-nav-main-menu-link');

  backLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      const submenu = link.closest('.navmenu-submenu.navmenu-meganav[data-accordion-content]');
      if (submenu && submenu.getAttribute('data-accordion-state') === 'open') {
        submenu.style.right = '100%';
      }
    });
  });

  const navLinks = document.querySelectorAll('.navmenu-link');

  navLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      const submenu = link.closest('.navmenu-item').querySelector('.navmenu-submenu');
      if (submenu) {
        submenu.style.right = '0%';
        submenu.setAttribute('data-accordion-state', 'open');
      }
    });
  });

});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.slideshow-pagination__button').forEach(function(btn) {
    btn.removeAttribute('aria-selected');
  });

  const pagination = document.querySelector('.slideshow-pagination');
  if (pagination) {
    new MutationObserver(function() {
      document.querySelectorAll('.slideshow-pagination__button').forEach(function(btn) {
        btn.removeAttribute('aria-selected');
      });
    }).observe(pagination, { attributes: true, subtree: true });
  }
});

